module.exports = __webpack_public_path__ + "img/coinmint.99f8579d.png";